import type { CustomerConfig } from '@peanuds/app-shell';
import { ORDER_CARD_ROUTE_NAME } from '@peanuds/cards';
import type { RegistrationCountry } from '@peanuds/shared';
import paymentFailedHero from './assets/media/payment/clear-bank-error.png';
import paymentSuccessHero from './assets/media/payment/clear-bank-success.png';
import smallScreenIllustration from './assets/media/small-screen/clear-bank-small-screen.png';
import totalBalancePromoImage from './assets/media/total-balance/clear-bank-promo-card.png';

const CLEAR_BANK_APP_NAME = 'ClearBank Demo';

const SUPPORTED_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
] as const satisfies readonly RegistrationCountry[];

/**
 * ClearBank Demo customer-specific configuration.
 *
 * This is the single source of truth for all customer-specific values
 * that features need at runtime (legal links, branding assets, etc.).
 *
 * Provided to the Vue app via `app.provide(CUSTOMER_CONFIG_KEY, customerConfig)`
 * in main.ts, and consumed by features via `useCustomerConfig()`.
 */
export const customerConfig: CustomerConfig = {
  appName: CLEAR_BANK_APP_NAME,
  links: {
    serviceAgreement: 'https://example.com/legal',
    privacyPolicy: 'https://example.com/legal',
    totalBalancePromoRouteName: ORDER_CARD_ROUTE_NAME,
  },
  media: {
    totalBalancePromoMedia: {
      src: totalBalancePromoImage,
      type: 'image',
    },
    paymentSuccessHero,
    paymentFailedHero,
    smallScreenIllustration,
  },
  countries: {
    registration: SUPPORTED_COUNTRIES,
  },
  notifications: {
    novuContext: {
      tenant: {
        id: 'clearbank',
        data: {
          applicationName: CLEAR_BANK_APP_NAME,
        },
      },
    },
  },
  dateTime: {
    locale: 'en-GB',
  },
  currency: {
    locale: 'en-GB',
    transactionAmount: {
      pattern: '{sign} {currencySymbol}{amount}',
    },
  },
};
